'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionsheet = require('./actionsheet');

var _actionsheet2 = _interopRequireDefault(_actionsheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _actionsheet2.default; /**
                                          * Created by jf on 15/11/26.
                                          */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/actionsheet/index.js
// module id = 1721
// module chunks = 7